import { isBeginLiveChatResponse } from "./AlmeLiveChatStartResponse/AlmeLiveChatStart";
const OperatorJoined = "Operator-Joined";
const OperatorLeft = "Operator-Left";
const SessionEnd = "Session-End";
const Agent = "Agent";
const User = "User";
const NotEngaged = "NotEngaged";
let innerHTMLText;
const isOperatorJoinedResponse = (response) => response.extensionData.MessageOrigin === OperatorJoined;
const isOperatorLeftResponse = (response) => response.extensionData.MessageOrigin === OperatorLeft;
const isOperatorLeftOrJoinedResponse = (response) => (isOperatorJoinedResponse(response) || isOperatorLeftResponse(response));
const isAgentSessionEndResponse = (response) => response.extensionData.MessageOrigin === SessionEnd && response.extensionData.SessionEndReason === Agent;
const isNotEngagedSessionEndResponse = (response) => { var _a; return response.extensionData.MessageOrigin === SessionEnd && ((_a = response.extensionData.SessionEndReason) === null || _a === void 0 ? void 0 : _a.includes(NotEngaged)); };
export const updateOperatorNameInBeginLiveChatResponse = (responses, history) => {
    var _a;
    const operatorJoinedResponse = responses.find(isOperatorJoinedResponse);
    if (operatorJoinedResponse) {
        for (let i = history.length - 1; i >= 0; i--) {
            if (isBeginLiveChatResponse(history[i])) {
                history[i].extensionData.operatorJoined = true;
                history[i].extensionData.operatorName = (_a = operatorJoinedResponse.extensionData.OperatorData) === null || _a === void 0 ? void 0 : _a.Name;
                break;
            }
        }
    }
};
export const updateOperatorNameInSessionEndResponse = (resp, history) => {
    var _a, _b;
    const sessionEndResponse = resp.find(isAgentSessionEndResponse);
    const newResponseLength = resp.length;
    const historyLength = history.length;
    if (sessionEndResponse) {
        let found = false;
        for (let i = 0; i < newResponseLength; i++) {
            if (isOperatorLeftResponse(resp[i])) {
                sessionEndResponse.extensionData.operatorName = (_a = resp[i].extensionData.OperatorData) === null || _a === void 0 ? void 0 : _a.Name;
                found = true;
                break;
            }
        }
        if (!found) {
            for (let i = historyLength - 1; i >= 0; i--) {
                const response = history[i];
                if (isOperatorLeftOrJoinedResponse(response)) {
                    sessionEndResponse.extensionData.operatorName = (_b = response.extensionData.OperatorData) === null || _b === void 0 ? void 0 : _b.Name;
                    break;
                }
            }
        }
    }
};
export const updateNameAsNotEngagedInSessionEndResponse = (resp, history, almeState) => {
    var _a, _b, _c, _d;
    const sessionEndResponse = resp.find(isNotEngagedSessionEndResponse);
    const historyLength = history.length;
    if (sessionEndResponse) {
        for (let i = historyLength - 1; i >= 0; i--) {
            innerHTMLText = ((_b = (_a = document.getElementById("alme-live-chat-banner-main-" + (i + 1).toString())) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.includes("Waiting for Representative")) ? true : false;
            if (((_c = history[i].text) === null || _c === void 0 ? void 0 : _c.includes("wait times")) || ((_d = history[i].text) === null || _d === void 0 ? void 0 : _d.includes("Welcome to")) || innerHTMLText) {
                almeState.didSessionEndAsNotEngaged = true;
                history[i].didSessionEndAsNotEngaged = true;
                Object.freeze(history[i].didSessionEndAsNotEngaged);
                Object.freeze(almeState.didSessionEndAsNotEngaged);
            }
        }
    }
};
export const updateSessionEndResponseWhenTimeout = (resp, almeState) => {
    const sessionEndResponse = resp.find(x => x.extensionData.MessageOrigin === SessionEnd && x.extensionData.SessionEndReason === User);
    if (almeState.isLiveChatSessionTimeout && sessionEndResponse) {
        sessionEndResponse.extensionData.isSessionTimeout = true;
        almeState.isLiveChatSessionTimeout = false;
    }
};
export const updateOperatorNameInBeginLiveChatResponseHistory = (history) => {
    var _a;
    let beginLiveChatIndex = -1;
    for (let i = 0; i <= history.length - 1; i++) {
        if (isBeginLiveChatResponse(history[i])) {
            beginLiveChatIndex = i;
        }
        if (isOperatorJoinedResponse(history[i]) && beginLiveChatIndex > 0) {
            history[beginLiveChatIndex].extensionData.operatorJoined = true;
            history[beginLiveChatIndex].extensionData.operatorName =
                (_a = history[i].extensionData.OperatorData) === null || _a === void 0 ? void 0 : _a.Name;
            beginLiveChatIndex = -1;
        }
    }
};
